import { Button, ButtonGroup } from "@material-ui/core";
import ClearAllIcon from "@material-ui/icons/ClearAll";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import GetAppIcon from "@material-ui/icons/GetApp";

interface Props {
	deleteItem?: () => void;
	editItem?: () => void;
	editAllItems?: () => void;
	downloadItem?: () => void;
	deleteLabel?: string;
	editLabel?: string;
	editAllLabel?: string;
	downloadLabel?: string;
}

export const AgGridHeaderButtons = ({
	deleteItem,
	editItem,
	editAllItems,
	downloadItem,
	downloadLabel,
	deleteLabel,
	editLabel,
	editAllLabel,
}: Props) => {
	return (
		<>
			<ButtonGroup>
				{editItem && (
					<Button
						color={"primary"}
						onClick={() => {
							editItem();
						}}
						title={editLabel || "Edit"}
						style={{
							padding: "2px",
						}}
					>
						<EditIcon style={{ cursor: "pointer" }} fontSize="small" />
					</Button>
				)}
				{editAllItems && (
					<Button
						color={"primary"}
						variant="outlined"
						onClick={() => {
							editAllItems();
						}}
						title={editAllLabel || "Edit All"}
						style={{
							padding: "2px",
						}}
					>
						<ClearAllIcon style={{ cursor: "pointer" }} fontSize="small" />
						<EditIcon style={{ cursor: "pointer" }} fontSize="small" />
					</Button>
				)}
				{deleteItem && (
					<Button
						color={"secondary"}
						onClick={() => {
							deleteItem();
						}}
						title={deleteLabel || "Delete"}
						style={{
							padding: "2px",
						}}
					>
						<DeleteIcon style={{ cursor: "pointer" }} fontSize="small" />
					</Button>
				)}
				{downloadItem && (
					<Button
						color={"primary"}
						onClick={() => {
							downloadItem();
						}}
						title={downloadLabel || "Get data"}
						style={{
							padding: "2px",
						}}
					>
						<GetAppIcon style={{ cursor: "pointer" }} fontSize="small" />
					</Button>
				)}
			</ButtonGroup>
		</>
	);
};
